module.exports = __webpack_public_path__ + "img/default-address.6a97b5b0.png";